<template>
  <div style="display: none;" class="auth-status" v-if="showDebug">
    <div class="auth-status-card">
      <h4>État d'authentification</h4>
      <div class="status-item">
        <span class="label">Statut:</span>
        <span class="value" :class="statusClass">{{ statusText }}</span>
      </div>
      <div class="status-item" v-if="authStore.token">
        <span class="label">Token:</span>
        <span class="value token">{{ truncatedToken }}</span>
      </div>
      <div class="status-item" v-if="authStore.error">
        <span class="label">Erreur:</span>
        <span class="value error">{{ authStore.error }}</span>
      </div>
      <div class="actions">
        <button @click="authStore.authenticate()" :disabled="authStore.isLoading" class="btn btn-primary btn-sm">
          {{ authStore.isLoading ? 'Connexion...' : 'Se connecter' }}
        </button>
        <button @click="authStore.logout()" :disabled="!authStore.isAuthenticated" class="btn btn-secondary btn-sm">
          Déconnexion
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '../stores/auth'

defineProps<{
  showDebug?: boolean
}>()

const authStore = useAuthStore()

const statusText = computed(() => {
  if (authStore.isLoading) return 'Chargement...'
  if (authStore.isAuthenticated) return 'Connecté'
  if (authStore.error) return 'Erreur'
  return 'Non connecté'
})

const statusClass = computed(() => {
  if (authStore.isLoading) return 'loading'
  if (authStore.isAuthenticated) return 'success'
  if (authStore.error) return 'error'
  return 'disconnected'
})

const truncatedToken = computed(() => {
  if (!authStore.token) return ''
  return authStore.token.substring(0, 20) + '...'
})
</script>

<style scoped>
.auth-status {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.auth-status-card {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 300px;
}

.auth-status-card h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
}

.status-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
}

.label {
  font-weight: bold;
  color: #666;
}

.value {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.value.success {
  color: #28a745;
}

.value.error {
  color: #dc3545;
}

.value.loading {
  color: #007bff;
}

.value.disconnected {
  color: #6c757d;
}

.value.token {
  font-family: monospace;
  font-size: 10px;
}

.actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
}

.btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}
</style>
